import { DataService } from './dataService'

export const signupQuoteService = {
    signupQuotes: async (data) => {
        return DataService.post('/user/quote_sign_up', data)
    }
}

export default signupQuoteService;